export default "__VITE_ASSET__CozOYY$3__"